import React from 'react';
import './style.css';

const WidthText = ({width}) => {
    return ( 

        <div id="width_container"><span>{width}</span></div>

     );
}
 
export default WidthText;